// ============================================================================
// cattle.dailys.detail — migrated off the global read
// ============================================================================
// The /cattle/dailys/<id> record page owns its two page-specific reads through
// cattle.daily.detail. Its record id is part of the resource key, so moving
// between daily reports is a key change rather than an unsafe local reload.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'cattle.dailys.detail',
  obligations: Object.freeze([Object.freeze({id: 'cattle.daily.detail', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
